import React from 'react';
import { hydrate, render } from 'react-dom';
import './index.css';
import App from './components/app/App';
// import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
//stopReportingRuntimeErrors();

// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register("./firebase-messaging-sw.js")
//     .then(function(registration) {
//       //console.log("Registration successful, scope is:", registration.scope);
//     })
//     .catch(function(err) {
//       //console.log("Service worker registration failed, error:", err);
//     });
// }

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  hydrate(<App />, rootElement);
} else {
  render(<App />, rootElement);
}
